import { render, staticRenderFns } from "./Duration.vue?vue&type=template&id=51286c4f&scoped=true"
import script from "./Duration.vue?vue&type=script&lang=js"
export * from "./Duration.vue?vue&type=script&lang=js"
import style0 from "./Duration.vue?vue&type=style&index=0&id=51286c4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51286c4f",
  null
  
)

export default component.exports